import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {IonicModule, PopoverController} from '@ionic/angular';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-switch-user-menu',
  templateUrl: './switch-user-menu.component.html',
  styleUrls: ['./switch-user-menu.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchUserMenuComponent {
  @Input() userSelected: boolean;

  constructor(private readonly popoverController: PopoverController) {}

  async menuChoice(action: string): Promise<void> {
    await this.popoverController.dismiss(action);
  }
}
